import Airdrop from './index';

export default { path: '/home/airdrop', component: Airdrop };
